import { Component } from '@angular/core';

@Component({
  template : 'This is what it says when there is not page at routed location requested.\n'
})
export class Page404Component{

}
